import React, { useState } from "react";
import Title from "./Title";
import styles from "./Prices.module.css";
import PriceTable from "./PriceTable";
import { useTranslation } from "../../context/TranslationContext";

const Prices = ({
  showAvailability,
  setShowAvailability,
  ProductId,
  start2,
}) => {
  const { pricesTitle, availabilityCalendar, nightly } = useTranslation();
  const isUkSite = process.env.NEXT_PUBLIC_SITE == 2;
  const [currency, setCurrency] = useState(isUkSite ? "pound" : "tl");

  const ShowAvailabilityToggle = () => {
    setShowAvailability(!showAvailability);
  };

  const CurrencyList = isUkSite
    ? [
        {
          name: "pound",
          text: "GBP",
        },
        {
          name: "tl",
          text: "TL",
        },
        {
          name: "dolar",
          text: "USD",
        },
        {
          name: "euro",
          text: "EUR",
        },
      ]
    : [
        {
          name: "tl",
          text: "TL",
        },
        {
          name: "dolar",
          text: "USD",
        },
        {
          name: "euro",
          text: "EUR",
        },
        {
          name: "pound",
          text: "GBP",
        },
      ];

  return (
    <div className="xl:mr-9 flex-1 lg:mb-5 xl:mb-0">
      <div className="flex justify-between">
        <Title>{pricesTitle}</Title>
        <button
          onClick={ShowAvailabilityToggle}
          className="bg-orange rounded-sm text-white py-2 self-center px-4 text-sm mb-3 lg:hidden"
        >
          {availabilityCalendar}
        </button>
      </div>
      <div className={"flex mt-6 lg:mt-2 z-10 relative " + styles.PricesTabs}>
        {CurrencyList.map((item, key) => {
          return (
            <button
              key={key}
              onClick={(e) => setCurrency(item.name)}
              className={item.name === currency ? styles.active : ""}
            >
              {item.text}
            </button>
          );
        })}
      </div>
      <div className="flex flex-col -mt-5">
        <div className="flex mb-5">
          <span className="ml-auto px-5 2xl:px-6 text-sm font-semibold text-primary">
            {nightly}
          </span>
          {/* <span className="px-5 2xl:px-6 text-sm font-semibold text-primary">
            Haftalık
          </span> */}
        </div>

        <PriceTable
          currency={currency}
          id={ProductId}
          start2={start2}
        ></PriceTable>
      </div>
    </div>
  );
};

export default Prices;
